import { Button, Grid, IconButton, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { AccountListDrawer } from "./AccountListDrawer";
import { PaymentPostingDrawer } from "./PamentPostingDrawer";

export const PaymentPosting: React.FC<any> = React.memo((props) => {
  const [cartOpen, setCartOpen] = useState(false);
  const navigate = useNavigate();
  const handleCartClick = () => {
    setCartOpen(true);
  };

  const handleCartClose = () => {
    setCartOpen(false);
  };

  const columns: IColumns[] = [
    {
      header: "No",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Invoice No",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Date",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Room",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Description",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "User",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Amount",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Paid",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Open",
      fieldName: "address",
      tooltip: true,
    },
  ];

  const handleClick = (path: string) => {
    navigate(path);
  };

  return (
    <Grid container direction="column" sx={{ minHeight: "100vh" }}>
      {/* Header Section */}
      <Grid item>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
          }}
        >
          {/* Title on the left */}
          <Typography variant="h6" sx={{ fontWeight: "bold", color: "green" }}>
            Payment Posting
          </Typography>
          <Grid sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton>
              <WSIcons.SyncIcon />
            </IconButton>
            <IconButton onClick={handleCartClick}>
              <WSIcons.SearchIcon />
            </IconButton>
            <PaymentPostingDrawer open={cartOpen} onClose={handleCartClose} />
            <IconButton>
              <WSIcons.CloseIcon
                sx={{ backgroundColor: "red", color: "white" }}
                onClick={() => handleClick("/accountlisting")}
              />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            border: "1px solid lightgray",
          }}
        >
          <Grid item xs={2}>
            <Typography variant="body1">Receipt No</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">Date</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">25/10/2024</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">Payment Type</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">Amount</Typography>
          </Grid>

          <Grid item xs={1}>
            <Typography variant="body1">0.000</Typography>
          </Grid>
        </Grid>
      </Grid>

      {/* DataGrid Section */}
      <Grid item sx={{ flex: 1 }}>
        <WSDataGrid id="itemGrid" title="" columns={columns} />
      </Grid>
      <Grid
        item
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "16px",
        }}
      >
        <Typography>Balance:</Typography>
        <Typography>0.00</Typography>
      </Grid>
      {/* Footer Section */}
      <Grid
        item
        sx={{
          backgroundColor: "#333",
          padding: "1rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Icon on the left */}
        <Grid item>
          <WSIcons.GTranslateIcon sx={{ color: "white" }} />
        </Grid>

        {/* Buttons on the right */}
        <Grid item sx={{ display: "flex", marginLeft: "auto" }}>
          <Button
            variant="outlined"
            sx={{
              width: "13rem",
              color: "white",
              borderColor: "green",
            }}
          >
            Print List
          </Button>
          <Button
            variant="outlined"
            sx={{
              ml: 2, // Adds space between the buttons
              color: "white",
              borderColor: "green",
            }}
          >
            Pay
          </Button>
          <Button
            variant="contained"
            sx={{
              ml: 2, // Adds space between the buttons
              backgroundColor: "green",
              "&:hover": {
                backgroundColor: "#388e3c",
              },
            }}
            onClick={() => handleClick("/accountlisting")}
          >
            Close
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
});
